import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

const ISO_DATETIME_RE = /^(\d{4})-(\d{2})-(\d{2})T/

export function formatIfDate(value: unknown): unknown {
  try {
    if (typeof value === 'string') {
      const trimmedValue = value.trim()
      const match = trimmedValue.match(ISO_DATETIME_RE)
      if (!match) return value

      const month = parseInt(match[2], 10)
      const day = parseInt(match[3], 10)
      if (month < 1 || month > 12 || day < 1 || day > 31) return value

      const parsedDate = dayjs.utc(trimmedValue)
      if (parsedDate.isValid()) {
        return parsedDate.format('MM/DD/YYYY')
      }
    }
    return value
  } catch {
    return value
  }
}
